import React, { Component } from "react";
import { connect } from "react-redux";

import { Wrapper, Scroll } from "app/NativeComponents/common";

import MessageDisplayItem from "./MessageDisplayItem";

class MessageDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate(prevProps) {}

  render() {
    if (this.props.message_display && this.props.message_display.length > 0) {
      return (
        <Wrapper>
          {this.props.message_display.map((message, i) => {
            return (
              <MessageDisplayItem
                key={"message_display_" + message.lead_phone_id}
                message={message}
                colors={this.props.colors}
                removeMessageDisplay={this.props.removeMessageDisplay}
              />
            );
          })}
        </Wrapper>
      );
    }
    return <Wrapper />;
  }
}

const mapStateToProps = ({ message }) => {
  const { message_display } = message;
  return {
    message_display
  };
};

export default connect(mapStateToProps, {})(MessageDisplay);
